// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__JUgXk","disabled":"FileBtn_disabled__3ImKa","warn":"FileBtn_warn__Zlt-N","fade":"FileBtn_fade__fNQMz"};